if (!customElements.get('debeyond-reviews')) {
  customElements.define('debeyond-reviews', class extends HTMLElement {
    connectedCallback() {
      try { this.reviews = JSON.parse(this.dataset.reviews); } catch { return; }
      if (!Array.isArray(this.reviews)) return;
      this.filter = this.querySelector('[data-review-filter]');
      this.sort = this.querySelector('[data-review-sort]');
      this.list = this.querySelector('[data-review-list]');
      this.more = this.querySelector('[data-review-more]');
      this.status = this.querySelector('[data-review-status]');
      this.limit = 6;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      [this.filter, this.sort].forEach(control => control.addEventListener('change', () => { this.limit = 6; this.render(); }, options));
      this.querySelectorAll('[data-review-rating]').forEach(button => button.addEventListener('click', () => {
        this.filter.value = this.filter.value === button.dataset.reviewRating ? 'all' : button.dataset.reviewRating;
        this.limit = 6;
        this.render();
      }, options));
      this.more.addEventListener('click', () => {
        const previous = this.list.children.length;
        this.limit += 6;
        this.render();
        const firstNew = this.list.children[previous];
        if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({preventScroll: true}); }
      }, options);
      this.closest('section').querySelector('[data-review-write]').addEventListener('click', event => {
        const form = document.querySelector('.db-feedback-form');
        if (!form) return;
        event.preventDefault();
        form.open = true;
        form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        form.querySelector('input:not([type="hidden"])')?.focus({preventScroll: true});
      }, options);
      this.querySelector('[data-review-controls]').hidden = false;
      this.render();
    }
    render() {
      const rows = this.reviews.filter(review => this.filter.value === 'all' || review.rating === Number(this.filter.value));
      if (this.sort.value !== 'original') rows.sort((a, b) => this.sort.value === 'highest' ? b.rating - a.rating : a.rating - b.rating);
      const fragment = document.createDocumentFragment();
      rows.slice(0, this.limit).forEach(review => {
        const article = document.createElement('article');
        article.className = 'db-review-card';
        const top = document.createElement('div');
        const heading = document.createElement('h3');
        const name = document.createElement('bdi');
        name.textContent = review.author;
        heading.append(name);
        const stars = document.createElement('span');
        stars.className = 'db-review-rating';
        stars.dir = 'ltr';
        stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
        stars.setAttribute('aria-label', this.dataset.scoreTemplate.replace('__SCORE__', String(review.rating)));
        top.append(heading, stars);
        const body = document.createElement('p');
        body.dir = 'auto'; body.lang = 'ar'; body.textContent = review.body;
        article.append(top, body); fragment.append(article);
      });
      this.list.replaceChildren(fragment);
      this.more.hidden = rows.length <= this.limit;
      this.status.textContent = this.dataset.statusTemplate.replace('__SHOWN__', String(Math.min(this.limit, rows.length))).replace('__TOTAL__', String(rows.length));
      this.querySelectorAll('[data-review-rating]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.reviewRating === this.filter.value)));
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
